import formatTimingPrefix from "./formatTimingPrefix";

const sentryLoginAppStartMetrics = () => {
    const timingPrefix = formatTimingPrefix();

    const loginAppStartTime = performance.now();
    const timeZero = sessionStorage.getItem(`${timingPrefix}timeZero`);
    const loginAppStartDelta = String(loginAppStartTime - Number(timeZero));

    const loginStartClickExists = sessionStorage.getItem(`${timingPrefix}loginAppStart`);

    if (loginStartClickExists) {
        // Remove old and set with new value
        sessionStorage.removeItem(`${timingPrefix}loginAppStart`);
    }

    sessionStorage.setItem(timingPrefix + "loginAppStart", loginAppStartDelta);
};

export default sentryLoginAppStartMetrics;
